<template>
  <v-btn v-if="isMainSystem" icon small @click="openInstruction">
    <app-tooltip>
      <v-icon small>fas fa-question-circle</v-icon>
      <template v-slot:tooltip>
        <div v-html="$t('appHelpButton.tooltips.showInstruction')"></div>
      </template>
    </app-tooltip>
  </v-btn>
</template>

<script>
import { showInstruction } from '@/helpers/instruction-helper';
import AppTooltip from '@/components/Common/AppTooltip';
import { actions as _act } from '@/models/store.actions';

export default {
  name: 'AppHelpButton',
  components: { AppTooltip },
  props: {
    instructionChapter: undefined
  },
  computed: {
    appSettings() {
      return this.$store.getters[_act.SETT_GET_APPSET];
    },
    isMainSystem() {
      return this.appSettings && this.appSettings.systemName === 'askod_online';
    }
  },
  methods: {
    openInstruction(e) {
      showInstruction(e.ctrlKey, this.instructionChapter);
    }
  }
};
</script>
